import * as React from "react"
import type { SVGProps } from "react"
const SvgCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 17.64q1.87 0 3.19-1.31a4.3 4.3 0 0 0 1.31-3.19q0-1.87-1.31-3.18A4.3 4.3 0 0 0 12 8.64q-1.87 0-3.19 1.32a4.3 4.3 0 0 0-1.31 3.18q0 1.88 1.31 3.19A4.3 4.3 0 0 0 12 17.64m0-2q-1.06 0-1.77-.72-.73-.72-.73-1.78c0-1.06.24-1.29.73-1.77q.72-.72 1.77-.73c1.05 0 1.3.25 1.78.73q.72.72.72 1.77c0 1.05-.24 1.3-.72 1.78q-.73.72-1.78.72m-8 5.5q-.82 0-1.41-.58A2 2 0 0 1 2 19.13v-12q0-.82.59-1.41A2 2 0 0 1 4 5.14h3.15L8.4 3.8a2 2 0 0 1 1.48-.65h4.25q.42 0 .8.18.4.17.67.47l1.25 1.35H20q.83 0 1.41.59.6.6.59 1.41v12q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm0-2h16v-12h-4.05l-1.82-2H9.87l-1.82 2H4z" />
  </svg>
)
export default SvgCamera
